import { Button } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { MY_URL } from '../../../../../constants/urls';

export function ProfileEditButton() {
  const { t } = useTranslation();

  return (
    <Button variant="default" size="sm" radius="md" component={Link} href={MY_URL.ACCOUNT()}>
      {t('프로필 수정')}
    </Button>
  );
}
